export const ASYNC_FETCH = 'ITP_PlanSelection/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESSPLAN = 'ITP_PlanSelection/ASYNC_FETCH_SUCCESSPLAN';
export const ASYNC_FETCH_FAILURE = 'ITP_PlanSelection/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_PlanSelection/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_PLAN = 'ITP_PlanSelection/SET_SELECTED_PLAN';
export const SET_SELECTED_OFFER = 'ITP_PlanSelection/SET_SELECTED_OFFER';
export const STOP_API_CALL = 'ITP_PlanSelection/STOP_API_CALL';
export const DISABLE_REVIEW_BAR = 'ITP_PlanSelection/DISABLE_REVIEW_BAR';
export const FIRST_CURRENT_PLAN = 'ITP_PlanSelection/FIRST_CURRENT_PLAN';
/**
 * action types
 * @type {string}
 */
